/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RttrFinalistEntry
 */
export interface RttrFinalistEntry {
    /**
     * 
     * @type {string}
     * @memberof RttrFinalistEntry
     */
    username: string;
    /**
     * User's avatar URL; empty/undefined when none uploaded (frontend falls back to initials).
     * @type {string}
     * @memberof RttrFinalistEntry
     */
    avatarUrl?: string;
    /**
     * Live current-round board score (RttrScore.byRound[activeRound]) — NOT frozen at qualification.
     * @type {number}
     * @memberof RttrFinalistEntry
     */
    value: number;
    /**
     * The round (segment index) this finalist qualified in — powers the R1/R2/R3 badge.
     * @type {number}
     * @memberof RttrFinalistEntry
     */
    qualifyingRound: number;
}

/**
 * Check if a given object implements the RttrFinalistEntry interface.
 */
export function instanceOfRttrFinalistEntry(value: object): value is RttrFinalistEntry {
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('qualifyingRound' in value) || value['qualifyingRound'] === undefined) return false;
    return true;
}

export function RttrFinalistEntryFromJSON(json: any): RttrFinalistEntry {
    return RttrFinalistEntryFromJSONTyped(json, false);
}

export function RttrFinalistEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RttrFinalistEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'value': json['value'],
        'qualifyingRound': json['qualifyingRound'],
    };
}

export function RttrFinalistEntryToJSON(json: any): RttrFinalistEntry {
    return RttrFinalistEntryToJSONTyped(json, false);
}

export function RttrFinalistEntryToJSONTyped(value?: RttrFinalistEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'avatarUrl': value['avatarUrl'],
        'value': value['value'],
        'qualifyingRound': value['qualifyingRound'],
    };
}

